import { render, staticRenderFns } from "./BlogHeader.vue?vue&type=template&id=5c1bbe59&scoped=true"
import script from "./BlogHeader.vue?vue&type=script&lang=js"
export * from "./BlogHeader.vue?vue&type=script&lang=js"
import style0 from "./BlogHeader.vue?vue&type=style&index=0&id=5c1bbe59&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1bbe59",
  null
  
)

export default component.exports